/**
 * Cross-environment Blockly core accessor (S1-P7 Blockly editor).
 *
 * `blockly/core` resolves to DIFFERENT builds depending on the environment,
 * via the package's `exports["./core"]` conditions:
 *   - Vite / browser  → `blockly.mjs`   (real ESM, named exports)
 *   - Node (.mjs unit tests, "node" condition) → `core-node.js` (CJS)
 *
 * Under the Node/CJS path an `import * as Blockly from 'blockly/core'` yields
 * `{ default: <Blockly>, 'module.exports': <Blockly> }` — so `Blockly.Workspace`
 * would be `undefined`. This shim normalizes both shapes so the SAME source
 * modules (block defs, NCalc generator, parser) work in the vite build AND in
 * the headless `node tests/*.mjs` runs.
 *
 * ALWAYS import Blockly through this module:
 *   import Blockly from '@/utils/blockly/blocklyCore.js'
 */
import * as BlocklyNS from 'blockly/core'

// Browser ESM exposes named exports on the namespace (no meaningful `default`);
// Node CJS-interop puts the whole object on `.default`. Prefer whichever has the API.
const Blockly = (BlocklyNS && BlocklyNS.default && BlocklyNS.default.Workspace)
  ? BlocklyNS.default
  : BlocklyNS

export default Blockly
